import React from "react";
import "./OurService.css";
import strategyIcon from "../../media/serviceicon.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Parent container animation
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.25, // controls the cascade delay
      delayChildren: 0.3, // delay before the first child starts
    },
  },
};

// Each card animation
const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

// Add this variant above the component
const leftContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

const leftItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};
const services = [
  {
    title: "Accounting",
    description:
      "We provide accurate, timely, and GAAP-compliant accounting services tailored to businesses, nonprofits, and government-funded organizations. From bookkeeping to financial statements, we ensure your financial records are clean, strategic, and compliance-ready.",
    link: "/accounting",
    icon: "bi-calculator", // suitable for accounting
  },
  {
    title: "Consulting",
    description:
      "Our consulting services are built on real-world experience. Whether you’re navigating rapid growth, restructuring, or internal control challenges, we bring expert guidance to optimize your financial operations and help you plan for sustainable success.",
    link: "/consulting",
    icon: "bi-bar-chart-line", // good for strategic planning/consulting
  },
  {
    title: "Grants",
    description:
      "Grants come with tremendous opportunities—and complex responsibilities. We specialize in grant accounting and compliance for educational institutions, nonprofits, and government-funded programs, ensuring your funding is used effectively and in compliance with federal and state regulations.",
    link: "/grants",
    icon: "bi-journal-check", // represents documents and compliance
  },
  {
    title: "Taxes",
    description:
      "Tax strategy is more than filing forms — it’s about planning ahead. We provide personalized tax planning and preparation for individuals, businesses, and nonprofits, helping you reduce liabilities while staying compliant with IRS and state requirements.",
    link: "/taxes",
    icon: "bi-file-earmark-text", // represents tax documentation
  },
];

const OurServices = () => {
  return (
    <section className="ourservices-section">
      <div className="container">
        <div className="row">
          {/* Left Section */}
          <motion.div
            className="col-lg-5 mb-4 mb-lg-0"
            variants={leftContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="ourservices-sticky">
              <motion.span className="ourservices-subtitle" variants={leftItem}>
                OUR SERVICES
              </motion.span>

              <motion.h1 className="ourservices-title" variants={leftItem}>
                We’re Your{" "}
                <span className="ourservices-title ourservices-title-span">
                  Strategic
                </span>{" "}
                Partner Every Step of the Way
              </motion.h1>

              <motion.p className="ourservices-description" variants={leftItem}>
                I founded Aspen SR Business Solutions with a vision to offer
                more than just accounting — we’re here to help businesses grow
                with clarity and confidence. Whether you're a startup needing
                structure, a nonprofit managing grant compliance, or an
                established business seeking financial insight, we’re ready to
                support you.
              </motion.p>

              <motion.button className="ourservices-button" variants={leftItem}>
                <Link to="/accounting" className="text-white">
                  VIEW OUR SERVICES
                </Link>
              </motion.button>
            </div>
          </motion.div>

          {/* Right Section - Animate Children in Order */}
          <div className="col-lg-7">
            <motion.div
              className="row g-4"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  className="col-md-6"
                  variants={cardVariants}
                >
                  <Link
                    to={service.link}
                    className="text-decoration-none text-dark"
                  >
                    <div className="ourservices-card h-100">
                      <i className={`bi ${service.icon} ourservices-icon`}></i>
                      <h2 className="ourservices-card-title">
                        {service.title}
                      </h2>
                      <p className="ourservices-card-description">
                        {service.description}
                      </p>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
